// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { ApiCadastroEndpoints } from './endpoints/api-cadastro-endpoints';
import { ApiLoginEndpoints } from './endpoints/api-login-endpoints';
import fingerPrintEdnpoints from './endpoints/ms-fingerprint-schema';
import mscotistaEndpoints from './endpoints/mscotista-endpoints';
import vxMaestroEndpoints from './endpoints/vxmaestro-endpoints';

export const environment = {
  suitabilityTerm: 'https://vxdocumentosestaticos.s3.sa-east-1.amazonaws.com/TERMO_DE_RECUSA_DO_QUESTION%C3%81RIO_DE_SUITABILITY_V4.pdf',
  paymentAccountOpeningTerm: 'https://vxdocumentosestaticos.s3.sa-east-1.amazonaws.com/CONTRATO_DE_ABERTURA_DE_CONTA_DE_PAGAMENTO.pdf',
  fingerprintJsKey: 'KkEqjSbOeMwkVJ9wY5TW',
  production: true,
  loginForceDev: false,
  site: 'https://vortx.com.br',
  authMiddlewareUrl: 'https://portal.vortx.com.br',
  refreshMiddlewareUrl: 'https://portal.vortx.com.br/login-refresh',
  authCookie: 'vxtoken',
  cryptoCookie: 'cryptoTokenV2',
  msCotista: 'https://publicservices.vortx.com.br/ms-cotista/graphql',
  msFingerprint: 'https://publicservices.vortx.com.br/fingerprint/',
  ...fingerPrintEdnpoints,
  vxMaestro: 'https://vxapi.vortx.com.br',
  ...vxMaestroEndpoints,
  ...mscotistaEndpoints,
  fakeJWTToken: '',
  fakeCryptoToken: '',
  ph3aSettings: {
    url: 'https://publicservices.vortx.com.br/apimanager',
    ph3aGetPersonData: 'PH3A_SETTINGS_GET_PERSON_DATA',
    ph3aGetCompanyData: 'PH3A_SETTINGS_GET_COMPANY_DATA',
    scoreRegistration: '/api/PH3A/GetScoreRegistration'
  },
  apiLoginSettings: {
    url: 'https://publicservices.vortx.com.br/vxlogin',
    ...ApiLoginEndpoints
  },
  apiCadastroSettings: {
    url: 'https://publicservices.vortx.com.br/vxcadastro',
    ...ApiCadastroEndpoints,
    // Suitability Custom Calculators
    suitabilityCustomCalcs: {
      personAverageIncomeQuestionID: '291d60bd-6124-40b2-986b-e319dd57065e',
      personInvestmentsCompositionAverageQuestionID: '5d018ecf-eee1-43a5-ae1b-7b335f140cc1',
      companyAverageIncomeQuestionID: '291d60bd-6124-40b2-986b-e319dd57065e',
      companyInvestmentsCompositionAverageQuestionID: '5d018ecf-eee1-43a5-ae1b-7b335f140cc1'
    }
  },
  viaCepSettings: {
    url: 'https://viacep.com.br/ws/',
    typeResult: 'json'
  },
  mixPanelSettings: {
    token: '1e3983a159afaddd9055988e205bb9ed',
    envName: 'prod'
  },
  logRocketApiKey: '80xttd/vxcadastro-prd',
  investorRepresentativeId: 'a8e88a4a-8496-4d85-bc0e-4c55dd31f210',
  enablePh3aIntegration: false,
  vortxCnpj: '22.610.500/0001-88',
  vortxCompanyName: 'VORTXDISTRIBUIDORADETITULOSEVALORESMOBILIARIOSLTDA',
  distributorSettings: {
    distributors: [
      {
        name: 'VORTXDISTRIBUIDORADETITULOSEVALORESMOBILIARIOSLTDA',
        document: '22610500000188'
      }
    ]
  }
};
